import mutations from './companySite.mutations'
import actions from './companySite.actions'
import getters from './companySite.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
